import React, { useState, useRef, useEffect } from 'react';
import { Input, useT } from '@repo/common';

const SummaryForm = ({ summary: initialSummary, setResumeData, $isMobile }) => {
  const t = useT();
  const containerRef = useRef(null);
  const [summary, setSummary] = useState(initialSummary || '');

  useEffect(() => {
    if (initialSummary !== undefined) {
      setSummary(initialSummary);
    }
  }, [initialSummary]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSummary(value);

    setResumeData((prev) => ({
      ...prev,
      summary: value,
    }));
  };

  return (
    <div ref={containerRef} className='w-full pb-[30px]'>
      <div className='relative min-w-[260px] max-w-[976px]'>
        <Input
          as='textarea'
          label=''
          placeholder={
            $isMobile
              ? t(
                  "e.g. I believe good design comes from taking ownership. I'm a junior designer with 3 years of experience who enjoys being deeply involved in the products I work on.",
                  '예: 좋은 디자인은 주인의식에서 나온다고 생각합니다.\n제품에 깊이 관여하는 것을 좋아하는 3년 차 주니어 디자이너입니다.',
                )
              : t(
                  `e.g. I believe good design comes from taking ownership.
I’m a junior designer with 3 years of experience who enjoys being deeply involved in the products I work on. Rather than just delivering screens, I like thinking through design decisions and collaborating closely with others to build thoughtful, user-centered services.`,
                  '예: 좋은 디자인은 주인의식에서 나온다고 생각합니다.\n제품에 깊이 관여하는 것을 좋아하는 3년 차 주니어 디자이너입니다. 단순히 화면을 만드는 데 그치지 않고, 디자인 의사결정을 고민하며 다른 사람들과 긴밀하게 협업해 사용자 중심의 서비스를 만드는 것을 좋아합니다.',
                )
          }
          value={summary}
          onChange={handleChange}
          maxLength={900}
          textareaMinHeight='151px'
          className='max-h-[151px]'
          textareaRows={5}
        />
      </div>
    </div>
  );
};

export default SummaryForm;
